import React, { FC, useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { useStaticInfo } from "../../../../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages, PREFIX } from "../../../../../../../i18n/i18n";
import { style as styleProfileSocialDescriptionStyle } from "./StyleProfileSocialDescription.style";

const StyleProfileSocialDescription: FC = () => {
  const {
    customer: { segment },
  } = useStaticInfo();

  const description = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.SOCIAL_SUBTITLE,
    prefix: PREFIX,
    values: { segment: segment.toLowerCase() },
  });

  const style = useMemo(() => styleProfileSocialDescriptionStyle(), []);

  return (
    <Text level={3} style={style.description}>
      {description}
    </Text>
  );
};

export { StyleProfileSocialDescription };
